import { extendObservable, action } from 'mobx';
import dataTypes from 'wf-utils/data/types';

// Space state constants
const VALUE_ABSENCE = 0;
const VALUE_PRESENCE = 1;
const VALUE_AVAIL = 2;
const VALUE_ALLOCATED = 3;
const VALUE_CHECKIN = 4;
const VALUE_CHECKOUT = 5;
const VALUE_UNKNOWN = -1;


class Space {
  store;

  id;

  name;

  srf;

  position;

  marker;

  category;

  department;

  locationId;

  capacity;



  constructor(store, id, name, srf, marker, category, department, locationId, capacity, livebaseurl, livewsurl, senses = {}) {
    this.store = store;
    this.id = id;

    this.name = name;
    this.srf = srf;
    this.marker = marker;
    this.category = category;
    this.department = department;
    this.locationId = locationId;
    this.capacity = capacity;


    extendObservable(this, {
      senses,
    });
  }


  /**
  If we want to customize the updates, this is the place to do that
  * */
  applyUpdate = action((update) => {
    let sense = 'availability'; // Some day, the sense will come in the update itself
    let state = VALUE_UNKNOWN;
    /**
      TemplateId   state number

      AVAILABLE     4  yellow
      CHECKIN       3  grey for whole day
      ALLOCATED     2  // reserved
      PRESENCE      1  grey  can be chaged
      ABSENCE       0  yellow

    **/
    if (update.dataType == dataTypes.CHECKIN) {
      sense = "spot";
      const utcEpoch = update.data.utcEpoch;
      if (update.data.value == "CHECKIN") {
        state = VALUE_CHECKIN;
      }
      if (update.data.value == "CHECKOUT") {
        state = VALUE_CHECKOUT;
      }
      if (update.data.value == "ALLOCATED") {
        state = VALUE_ALLOCATED;
      }
      if (update.data.value == "AVAILABLE") {
        state = VALUE_AVAIL;
      }
      // if (update.data.value=="BLOCKED") {
      //   state = VALUE_BLOCKED;
      // }

      this.assignState(sense, state, utcEpoch);
    }
    else if (update.dataType == dataTypes.OCCUPANCY_POLICY) {
      sense = "device";
      const utcEpoch = update.data.utcEpoch;
      if (update.data.value == "PRESENCE") {
        state = VALUE_PRESENCE;
      }
      if (update.data.value == "ABSENCE") {
        state = VALUE_ABSENCE;
      }
      this.assignState(sense, state, utcEpoch)
    }

    let result = this.setAvailabilitystate(update)
    this.assignState("availability", result, Date.now());

  })


  checkPrecedenceEvent(sense, state, timestamp) {
    if (sense === "availability") {
      return true;
    }
    if (timestamp > this.senses[sense].timestamp) {
      return true;
    }
    if (timestamp === this.senses[sense].timestamp) {
      return state > this.senses[sense].state;
    }

    return false;
  }

  assignState = action((sense, state, timestamp) => {
    if (this.senses[sense]) {
      if (this.checkPrecedenceEvent(sense, state, timestamp)) {
        Object.assign(this.senses[sense], { state, timestamp });
      }
    }

    else {
      extendObservable(this.senses, {
        [sense]: { state, timestamp },
      });
    }

  })


  setAvailabilitystate = (update) => {
    if (!this.senses || (!this.senses.spot && !this.senses.device)) {
      return VALUE_UNKNOWN;
    }

    if (!this.senses.spot) {
      return this.senses.device.state;
    }

    if (!this.senses.device) {
      return this.senses.spot.state;
    }

    // if(this.senses.spot.state==VALUE_BLOCKED){
    //   return VALUE_BLOCKED;
    // }

    if(this.senses.spot.state==VALUE_CHECKIN || this.senses.spot.state==VALUE_CHECKOUT ){
      return this.senses.spot.state;
    }

    if (this.senses.spot.state == VALUE_ALLOCATED) {
      return this.senses.device.state == VALUE_PRESENCE ? VALUE_PRESENCE : VALUE_ALLOCATED;
    }

    if (this.senses.spot.state == VALUE_AVAIL) {

      if (this.senses.device.state == VALUE_ABSENCE) {
        return this.senses.device.timestamp > this.senses.spot.timestamp ? VALUE_ABSENCE : VALUE_AVAIL;
      }

      if (this.senses.device.state == VALUE_PRESENCE) {
        return VALUE_PRESENCE;
      }
    }

    console.debug("update failed", update)
    console.debug("senses failed", this.senses)
    return VALUE_UNKNOWN;
  }


  setPositionForView(width, height, angle, offset = { x: 0, y: 0 }) {
    angle = (angle + 360) % 360;
    if (angle === 180) {
      angle = 0;
    } else if (angle === 270) {
      angle = 90;
    }
    const xy = this.srf;
    let o;
    if (angle === 0) {
      o = xy;
    } else if (angle === 180) {
      o = { x: width - xy.x, y: height - xy.y };
    } else if (angle === 90) {
      o = { x: height - xy.y, y: xy.x };
    } else if (angle === 270) {
      o = { x: xy.y, y: width - xy.x };
    } else {
      throw new Error(`Unsupported orientation: ${angle}`);
    }
    this.position = { x: o.x + offset.x, y: o.y + offset.y };
  }

  static fromJSON(store, json) {
    const { id, name, srf, market, category, department, locationId, capacity } = json;
    return new Space(store, id, name, srf, market, category, department, locationId, capacity);
  }
}

export default Space;
